import { render, staticRenderFns } from "./_remittanceTransactions.vue?vue&type=template&id=18e81443&scoped=true&"
import script from "./_remittanceTransactions.vue?vue&type=script&lang=js&"
export * from "./_remittanceTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e81443",
  null
  
)

export default component.exports